import { PaymentErrorShortCodes } from '../../Interfaces';
import { PaymentValidationError } from '../../Errors';
var BillingMethodEPaperToken = /** @class */ (function () {
    function BillingMethodEPaperToken(ePaperTokenInfo) {
        this.ePaperToken = BillingMethodEPaperToken.formatEPaperToken(ePaperTokenInfo.ePaperToken);
        this.expiration = {
            month: BillingMethodEPaperToken.formatExpirationMonth(ePaperTokenInfo.expiration.month),
            year: BillingMethodEPaperToken.formatExpirationYear(ePaperTokenInfo.expiration.year)
        };
        BillingMethodEPaperToken.isValidExpirationDate(this.expiration.month, this.expiration.year);
    }
    BillingMethodEPaperToken.formatEPaperToken = function (ePaperToken) {
        BillingMethodEPaperToken.isValidEPaperToken(ePaperToken);
        return ePaperToken;
    };
    BillingMethodEPaperToken.isValidEPaperToken = function (ePaperToken) {
        if (!/^[exEX]{2}[a-zA-Z0-9]{10}[0-9]{4}$/.test(ePaperToken)) {
            throw new PaymentValidationError('ePaper Token contains illegal characters or has illegal format', PaymentErrorShortCodes.invalid_epaper_token);
        }
        return true;
    };
    BillingMethodEPaperToken.formatExpirationMonth = function (month) {
        BillingMethodEPaperToken.isValidExpirationMonth(month);
        return ('0' + month).slice(-2);
    };
    BillingMethodEPaperToken.isValidExpirationMonth = function (month) {
        if (!/^(0?[1-9]|1[012])$/.test(month)) {
            throw new PaymentValidationError('ePaper Token expiration month is invalid, must be between 1 and 12', PaymentErrorShortCodes.invalid_expiration_month);
        }
        return true;
    };
    BillingMethodEPaperToken.formatExpirationYear = function (year) {
        BillingMethodEPaperToken.isValidExpirationYear(year);
        if (year.length === 2) {
            var yearPrefix = new Date().getUTCFullYear().toString().slice(0, 2);
            return "".concat(yearPrefix).concat(year);
        }
        else {
            return year;
        }
    };
    BillingMethodEPaperToken.isValidExpirationYear = function (year) {
        if (!/^\d{2}(\d{2})?$/.test(year)) {
            throw new PaymentValidationError('ePaper Token expiration year is invalid, must be in either YY or YYYY format', PaymentErrorShortCodes.invalid_expiration_year);
        }
        return true;
    };
    BillingMethodEPaperToken.isValidExpirationDate = function (month, year) {
        var currentYear = new Date().getUTCFullYear().toString();
        var currentMonth = (new Date().getMonth() + 1).toString();
        var formattedCurrentMonth = ('0' + currentMonth).slice(-2);
        if (currentYear > year || (currentYear === year && formattedCurrentMonth > ('0' + month).slice(-2))) {
            throw new PaymentValidationError('Card expiration date is in the past', PaymentErrorShortCodes.invalid_expiration_date_in_the_past);
        }
        return true;
    };
    return BillingMethodEPaperToken;
}());
export { BillingMethodEPaperToken };
